enum TipoCalculoAssociacao {
    Ativo = 0,
    VolumeTotal = 1
}

export default TipoCalculoAssociacao;